import { logger } from '@/services/logger/loggers'
import { clearState } from '@/store/index'
import { anonymizeTracking } from '@/services/tracking'
import { featureFlag } from '@/services/featureFlagProvider'
import { auth } from '@/modules/auth'

let logoutInFlight: Promise<void> | null = null

export const logout = async () => {
  if (logoutInFlight) {
    return logoutInFlight
  }

  logoutInFlight = (async () => {
    let remoteLogoutSucceeded = false

    try {
      if (auth.value) {
        await auth.value.logout()
        remoteLogoutSucceeded = true
      } else {
        logger.warn('[otters-shell - logout]: Auth module is not loaded', {})
      }
    } catch (error) {
      logger.error('[otters-shell - logout]: Remote logout failed', { error })
    } finally {
      try {
        clearState()
      } catch (error) {
        logger.error('[otters-shell - logout]: Failed to clear store state', {
          error,
        })
      }

      try {
        logger.unsetUserData()
      } catch (error) {
        logger.error(
          '[otters-shell - logout]: Failed to unset user data in logger',
          { error }
        )
      }

      try {
        anonymizeTracking()
      } catch (error) {
        logger.error('[otters-shell - logout]: Failed to anonymize tracking', {
          error,
        })
      }

      try {
        await featureFlag.anonymize()
      } catch (error) {
        logger.error(
          '[otters-shell - logout]: Failed to anonymize feature flags',
          { error }
        )
      }

      // Hard fallback: if remote logout didn't succeed, force a full-page navigation.
      // Use href (not router) to avoid MF/router races during teardown.
      if (!remoteLogoutSucceeded && typeof window !== 'undefined') {
        setTimeout(() => {
          try {
            window.location.href = '/'
          } catch (error) {
            logger.error('[otters-shell - logout]: Failed to redirect to /', {
              error,
            })
          }
        }, 0)
      }
    }
  })().finally(() => {
    logoutInFlight = null
  })

  return logoutInFlight
}
